// TEMP FEATURE — leverage-increase indicator.
// When a market's max leverage is raised above the previous baseline, we can surface it in two places:
//   - a dot + up-arrow on the leverage button (order_type_bar)
//   - an "increased from {from}x → {to}x" line in the Adjust Leverage modal (account_leverage)
//
// Currently DISABLED for all markets: RAISED_LEVERAGE_SYMBOLS is empty, so getLeverageIncrease()
// always returns null. Leverage is expected to rise on more markets going forward and we don't want
// to keep drawing attention to each change, so the indicator stays off for now. To highlight a
// market again, add its base-asset symbol to RAISED_LEVERAGE_SYMBOLS. To retire the indicator
// entirely, delete this module and its two call sites.

import type { MarketData } from '@/common/MarketData';

/** Previous max leverage baseline used to compute the "increased from" value. */
const PREVIOUS_MAX_LEVERAGE = 10;

/** Base-asset symbols whose max-leverage increase should be highlighted. Empty = indicator off. */
const RAISED_LEVERAGE_SYMBOLS = new Set<string>();

export interface LeverageIncrease {
  from: number;
  to: number;
}

/**
 * Returns the leverage increase for the given market, or `null` when none applies
 * (not an affected market, or its max leverage is still at/below the old baseline).
 */
export function getLeverageIncrease(marketData?: MarketData): LeverageIncrease | null {
  const symbol = marketData?.symbol;
  const maxLeverage = marketData?.initialMarginFraction;
  if (symbol == null || maxLeverage == null) return null;
  if (!RAISED_LEVERAGE_SYMBOLS.has(symbol)) return null;
  if (maxLeverage <= PREVIOUS_MAX_LEVERAGE) return null;
  return { from: PREVIOUS_MAX_LEVERAGE, to: maxLeverage };
}
